module.exports = __webpack_public_path__ + "static/img/ppt.865109de.png";